import { handleServiceError } from '../utils/errorHandler';
import type { PaginatedResponse } from '../types/student';
import type { PaginationInfo } from '../types';
import type { SystemLog, SystemLogFilters } from '../types/systemLog';
import { requestEdgeFunction } from './edgeFunctionClient';

const SYSTEM_LOG_COLUMNS = [
  'id',
  'occurred_at',
  'log_level',
  'log_system',
  'message',
  'payload',
  'function_name',
  'operation',
  'request_id',
  'user_id',
  'http_status',
].join(', ');

const sanitizeSearch = (value?: string) => value?.trim().replace(/[,%()]/g, ' ').replace(/\s+/g, ' ') ?? '';

const buildPagination = (
  page: number,
  pageSize: number,
  totalRecords: number,
): PaginationInfo => {
  const totalPages = totalRecords > 0 ? Math.ceil(totalRecords / pageSize) : 0;

  return {
    page,
    pageSize,
    totalRecords,
    totalPages,
    hasNextPage: page < totalPages,
    hasPreviousPage: page > 1,
  };
};

export type PaginatedSystemLogResponse = PaginatedResponse<SystemLog>;

class SystemLogServiceClass {
  async listPaginated(
    page: number = 1,
    pageSize: number = 20,
    filters: SystemLogFilters = {},
  ): Promise<PaginatedSystemLogResponse> {
    const response = await requestEdgeFunction<PaginatedSystemLogResponse>('frontend-logs', {
      method: 'GET',
      query: {
        page,
        pageSize,
        search: sanitizeSearch(filters.search),
        logLevel: filters.logLevel,
        logSystem: filters.logSystem,
        dateFrom: filters.dateFrom,
        dateTo: filters.dateTo,
      },
    }).catch((error) => {
      handleServiceError(error, 'listar logs');
      throw error;
    });

    return {
      data: (response.data ?? []) as unknown as SystemLog[],
      pagination: response.pagination ?? buildPagination(page, pageSize, 0),
    };
  }
}

export const SystemLogService = new SystemLogServiceClass();